import xgGeneral from '@/store/modules/xg/general';

export default {
  xgGeneral,
};
